<template>
  <div class="ui container">
    <div class="ui three item pointing menu" ref="tabs">
      <a class="active item" data-tab="list"
        ><i class="list icon"></i>{{ $t("api list") }}</a
      >
      <a class="item" data-tab="files"
        ><i class="code icon"></i>{{ $t("code files") }}</a
      >
      <a class="item" data-tab="dynamic_jwt"
        ><i class="js icon"></i>{{ $t("dynamic jwt") }}</a
      >
    </div>
    <api-list class="ui bottom attached active tab segment" data-tab="list" />
    <code-files class="ui bottom attached tab segment" data-tab="files" />
    <dynamic-jwt
      class="ui bottom attached tab segment"
      data-tab="dynamic_jwt"
    />
  </div>
</template>

<script>
import filters from "@/filters";
import ApiList from "./APIList.vue";
import CodeFiles from "./CodeFiles.vue";
import DynamicJwt from "./DynamicJwt.vue";

// @ is an alias to /src
export default {
  name: "APIManagerIndex",
  components: { ApiList, CodeFiles, DynamicJwt },
  filters: filters,
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    setTimeout(() => {
      window
        .jQuery(this.$refs.tabs)
        .find(".item")
        .tab();
    }, 500);
  },
  watch: {},
};
</script>
